import React from "react";
import { Paper, Typography, Theme } from "@mui/material";
import { motion } from "framer-motion";

interface ContentSectionProps {
  title: string;
  content: string;
  delay?: number;
  theme: Theme;
}

const ContentSection: React.FC<ContentSectionProps> = ({
  title,
  content,
  delay = 0,
  theme,
}) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5, delay }}
  >
    <Paper
      elevation={1}
      sx={{
        p: 3,
        mb: 3,
        borderRadius: 2,
        backgroundColor: "white",
        transition: "transform 0.3s, box-shadow 0.3s",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: theme.shadows[4],
        },
      }}
    >
      <Typography
        variant="h6"
        fontWeight={600}
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 2,
          color: theme.palette.primary.main,
        }}
      >
        {title}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        {content}
      </Typography>
    </Paper>
  </motion.div>
);

export default ContentSection;
